import React from 'react';

export default function TermsAndConditions() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 bg-[#1A1A1A] min-h-screen">
      <h1 className="text-3xl font-bold mb-6 text-center text-[#D4AF37]">TÉRMINOS Y CONDICIONES</h1>
      <p className="text-center text-[#F8F8F8]/70 mb-8">Última actualización: Febrero 2026</p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">1. Naturaleza del Servicio</h2>
      <p className="mb-4 text-[#F8F8F8]">Kiniela es una plataforma digital que ofrece concursos de pronósticos deportivos por jornada, donde los participantes realizan predicciones sobre los resultados de partidos de fútbol y compiten por una bolsa acumulada conformada por las aportaciones de los propios participantes.</p>
      <p className="mb-4 text-[#F8F8F8]">Kiniela no opera como casino ni como casa de apuestas tradicional, sino como un concurso de pronósticos con bolsa común entre participantes.</p>
      <p className="mb-4 text-[#F8F8F8]">El uso de la plataforma implica la aceptación total de estos Términos y Condiciones.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">2. Requisitos de Participación</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>Tener al menos 18 años cumplidos.</li>
        <li>Contar con capacidad legal para contratar en México.</li>
        <li>Proporcionar información verídica y actualizada.</li>
        <li>Operar únicamente una cuenta personal.</li>
      </ul>
      <p className="mb-4 text-[#F8F8F8]">Kiniela podrá solicitar verificación de identidad (KYC), incluyendo identificación oficial (INE), correo electrónico y número telefónico.</p>
      <p className="mb-4 text-[#F8F8F8]">En caso de detectar información falsa o uso indebido, la cuenta podrá ser suspendida o cancelada.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">3. Registro y Cuenta</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>Solo se permite una cuenta por persona.</li>
        <li>Las cuentas deberán validarse mediante identificación oficial (INE), verificación de correo electrónico y validación de número telefónico.</li>
        <li>Se prohíbe la creación de múltiples cuentas.</li>
        <li>El usuario es responsable de mantener la confidencialidad de su contraseña.</li>
      </ul>
      <p className="mb-4 text-[#F8F8F8]">En caso de detectar multi-cuentas, Kiniela podrá cancelar cuentas y anular participaciones.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">4. Funcionamiento del Concurso</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>La modalidad es quiniela clásica por jornada.</li>
        <li>El participante deberá pronosticar los resultados de todos los partidos indicados.</li>
        <li>El ganador será quien obtenga mayor número de aciertos.</li>
        <li>En caso de empate en número de aciertos, la bolsa se dividirá en partes iguales entre los empatados.</li>
        <li>Si un partido es cancelado o pospuesto, no será considerado para efectos del concurso.</li>
        <li>Si ningún participante obtiene aciertos válidos conforme a las reglas de la jornada, las cantidades aportadas serán devueltas al saldo (wallet) de cada participante.</li>
        <li>Las reglas específicas de cada jornada podrán publicarse dentro de la plataforma.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">5. Bolsa Acumulada y Comisión</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>La bolsa acumulada se conforma exclusivamente por las aportaciones de los participantes.</li>
        <li>Kiniela retendrá el 10% del total acumulado como comisión por concepto de operación y administración de la plataforma.</li>
        <li>El 90% restante será distribuido entre los ganadores conforme a lo establecido en estos Términos.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">6. Depósitos</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>Métodos de depósito disponibles: Transferencia vía CLABE.</li>
        <li>El monto máximo permitido por transacción es de $10,000 MXN.</li>
        <li>Los depósitos deberán provenir de cuentas a nombre del titular registrado.</li>
        <li>Kiniela podrá rechazar depósitos que considere irregulares.</li>
        <li>Los fondos depositados se reflejarán en el wallet del usuario una vez confirmados.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">7. Retiros</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>El monto mínimo de retiro es de $100 MXN.</li>
        <li>No existe monto máximo de retiro; el usuario podrá retirar el saldo disponible.</li>
        <li>Los retiros serán procesados en un plazo máximo de 48 horas hábiles.</li>
        <li>Kiniela podrá solicitar verificación adicional antes de procesar un retiro.</li>
        <li>Los retiros se realizarán preferentemente mediante el mismo método utilizado para el depósito inicial.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">8. Cancelación y Suspensión de Cuentas</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>Kiniela podrá suspender o cancelar cuentas cuando exista sospecha de fraude, colusión, uso de múltiples cuentas, incumplimiento de estos Términos o irregularidades en el comportamiento de juego.</li>
        <li>En estos casos, Kiniela podrá retener temporalmente fondos mientras se realiza la investigación correspondiente.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">9. Juego Responsable</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>Kiniela promueve la participación responsable.</li>
        <li>El usuario reconoce que participa voluntariamente y que existe la posibilidad de no obtener ningún premio.</li>
        <li>Si el usuario considera que su participación afecta su bienestar financiero o personal, deberá abstenerse de utilizar la plataforma.</li>
        <li>Kiniela podrá permitir la autoexclusión voluntaria.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">10. Fallas Técnicas</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>Kiniela no será responsable por fallas en conexión a internet del usuario, errores derivados de dispositivos del usuario o interrupciones temporales del servicio por mantenimiento.</li>
        <li>En caso de error evidente en la publicación de resultados o fallas del sistema, Kiniela podrá corregir la situación conforme a criterios razonables y transparentes.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">11. Limitación de Responsabilidad</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>El usuario reconoce que la participación en los concursos implica riesgo de no obtener premio.</li>
        <li>Kiniela no garantiza ganancias.</li>
        <li>Kiniela no es institución financiera ni genera rendimientos sobre saldos.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">12. Protección de Datos</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>Kiniela recolecta datos personales para verificación de identidad, prevención de fraude, procesamiento de depósitos y retiros, y cumplimiento legal.</li>
        <li>El tratamiento de datos se realizará conforme a la legislación mexicana aplicable.</li>
        <li>El Aviso de Privacidad se publicará por separado.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">13. Modificaciones</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>Kiniela podrá modificar estos Términos en cualquier momento. Las modificaciones serán publicadas en la plataforma.</li>
        <li>El uso continuo del servicio implica aceptación de los cambios.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#D4AF37]">14. Jurisdicción</h2>
      <ul className="mb-4 list-disc pl-6 text-[#F8F8F8]">
        <li>Estos Términos se rigen por las leyes mexicanas.</li>
        <li>Para cualquier controversia, las partes se someten a los tribunales competentes de Guadalajara, Jalisco, renunciando a cualquier otro fuero que pudiera corresponderles.</li>
      </ul>
    </div>
  );
}
